import { defineComponent as _defineComponent } from 'vue'
import StoreList from '../components/StoreList.vue';
import router from '../router/index'


export default /*#__PURE__*/_defineComponent({
  __name: 'StoresView',
  setup(__props) {


const breadcrumbItems = [
  {
    text: 'Stores',
    disabled: false,
    href: router.match({
      name: 'stores',
    }).path,
  },
]


return { __sfc: true,breadcrumbItems, StoreList }
}

})